import React from 'react';
import { Flex } from '@atlaskit/primitives';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { PageHeaderLoader } from './common/page-header-loader';
import { CollapsibleSummaryTableLoader } from './common/collapsible-summary-table-loader';

export const CatalogDetailsPageLoader = () => {
  return (
    <div className="pl-8">
      <PageHeaderLoader hasLeftIcon />
      <SkeletonLoaderWrapper>
        <Flex>
          <SkeletonLoader width="10%" marginBottom="8px" />
          <SkeletonLoader width="10%" marginBottom="8px" />
          <SkeletonLoader width="10%" marginBottom="8px" />
          <SkeletonLoader width="10%" marginBottom="8px" />
          <SkeletonLoader width="5%" marginBottom="8px" />
        </Flex>
      </SkeletonLoaderWrapper>
      <br />
      <br />
      <CollapsibleSummaryTableLoader tableColumnCount={3} />
    </div>
  );
};
